import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const pains = ['Cobrás menos de lo que realmente hacés.', 'Dudás cuando te piden un descuento.', 'Frenás todo cuando no podés estar encima.', 'Aceptás acuerdos que no te convienen.', 'Te cuesta explicar por qué tu trabajo vale.', 'No entendés por qué cada mes facturás distinto.'];
export function ProblemAgitation() {
  return <section className="bg-brand-navy px-6 py-24 text-white lg:px-8" data-id="element-208">
      <div className="mx-auto max-w-4xl" data-id="element-209">
        <motion.header initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto mb-12 max-w-3xl text-center" data-id="element-210">
          <h2 className="text-3xl font-extrabold leading-tight md:text-5xl" data-id="element-211">
            Trabajás mucho, pero seguís cobrando poco.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/75 md:text-xl" data-id="element-212">
            Sabés hacer tu trabajo. Te falta orden para cobrar y explicar mejor.
          </p>
        </motion.header>

        <div className="rounded-3xl border border-white/10 bg-white/5 p-7 md:p-10" data-id="element-213">
          <ul className="space-y-5" data-id="element-214">
            {pains.map((pain, index) => <motion.li key={pain} initial={{
            opacity: 0,
            x: -14
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex items-start gap-3 text-base text-white/90 md:text-lg" data-id="element-215">
                <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-400" data-id="element-216" />
                {pain}
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}